import React, { useContext, useState, useEffect } from "react";
import {
  Grid,
  Radio,
  Stack,
  Button,
  Typography,
  IconButton,
  RadioGroup,
  FormControl,
  FormControlLabel,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import { useMutation } from "@apollo/client";
import { BiMinusCircle } from "react-icons/bi";

// Project imports
import "../../../../../Style/dialogstyle.scss";
import { AuthContext } from "../../../../../Context/AuthContext";
import { UPDATE_STUDENT_ENROLLMENT_STATUS } from "../../../../../Schema/Class";

export default function Status({ open, editData, setRefetch, handleClose }) {
  const { setAlert, t } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState("");

  useEffect(() => {
    if (editData?.status) setValue(editData.status);
  }, [editData]);

  const [updateStudentEnrollmentStatus] = useMutation(
    UPDATE_STUDENT_ENROLLMENT_STATUS,
    {
      onCompleted: ({ updateStudentEnrollmentStatus }) => {
        setLoading(false);
        if (updateStudentEnrollmentStatus?.isSuccess) {
          setAlert(true, "success", updateStudentEnrollmentStatus.message);
          setRefetch();
          handleClose();
        } else {
          setAlert(true, "error", updateStudentEnrollmentStatus.message);
        }
      },
      onError: ({ message }) => {
        setLoading(false);
        setAlert(true, "error", {
          messageEn: message,
          messageKh: message,
        });
      },
    }
  );

  const handleSubmit = () => {
    setLoading(true);
    updateStudentEnrollmentStatus({
      variables: {
        id: editData?._id,
        status: value,
      },
    });
  };

  const statusOptions = [
    { value: "studying", label: t("thead_studying"), color: "green" },
    { value: "complete", label: t("thead_completed"), color: "blue" },
    { value: "dropout", label: t("thead_dropout"), color: "red" },
    { value: "stopout", label: t("thead_stopout"), color: "orange" },
  ];

  return (
    <Dialog open={open} className="dialog-container" maxWidth="xs" fullWidth>
      <DialogTitle sx={{ padding: "10px 20px" }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography className="dialog-title">
            {t("modal_title_study_status")}
          </Typography>
          <IconButton onClick={handleClose}>
            <BiMinusCircle className="close-icon" />
          </IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormControl>
              <RadioGroup
                value={value}
                onChange={(e) => setValue(e.target.value)}
              >
                {statusOptions.map((option) => (
                  <FormControlLabel
                    key={option.value}
                    value={option.value}
                    control={
                      <Radio
                        sx={{
                          color: option.color,
                          "&.Mui-checked": { color: option.color },
                        }}
                      />
                    }
                    label={option.label}
                  />
                ))}
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <Button
              className="btn-create"
              fullWidth
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? t("loading") : t("update")}
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
